export default [
  {
    title: "의무이행사항 점검결과(직접관리 시설)",
    footer: "※ <span style='color: #EA5455'>(필수)</span> ① 항목별 증빙자료 첨부(4번 안전계획은 제출필요 없음)<br/>" +
      "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
      "② 중복자료는 1건만 제출: 증빙자료에 관련 체크리스트 식별번호 기재 예)5-1~4, 9",
    list: [
      {
        title: "1. 필요한 안전인력을 확보하였음.(업무분장표 첨부)",
        content: "① 안전점검(유해위험요인 확인) 및 유지보수 업무",
        isChecked: "",
      },
      {
        title: "1. 필요한 안전인력을 확보하였음.(업무분장표 첨부)",
        content: "② 안전계획 수립 및 매뉴얼작성 등",
        isChecked: "",
      },
      {
        content: "<span style='font-weight: 600;'>2. 필요한 안전예산을 편성하고 집행하였음.</span>",
        contentBackgroundColor: "#f9f9f9",
      },
      {
        title: "3. 안전점검 계획(계획서 첨부)",
        content: "① 수립(문서화)",
        isChecked: "",
      },
      {
        title: "3. 안전점검 계획(계획서 첨부)",
        content: "② 수행(점검 위탁 포함)",
        isChecked: "",
      },
      {
        title: "4. 안전계획 <span style='font-weight: 500;'>※ 아래 항목 중 실제 안전계획에 포함한 사항만 체크</span>",
        content: "① 수립(문서화)",
        isChecked: "",
      },
      {
        title: "4. 안전계획 <span style='font-weight: 500;'>※ 아래 항목 중 실제 안전계획에 포함한 사항만 체크</span>",
        content: "② 안전관리 대상 현황",
        isChecked: "",
      },
      {
        title: "4. 안전계획 <span style='font-weight: 500;'>※ 아래 항목 중 실제 안전계획에 포함한 사항만 체크</span>",
        content: "③ 조직 및 인력확보",
        isChecked: "",
      },
      {
        title: "4. 안전계획 <span style='font-weight: 500;'>※ 아래 항목 중 실제 안전계획에 포함한 사항만 체크</span>",
        content: "④ 안전예산 편성현황(세부항목별)",
        isChecked: "",
      },
      {
        title: "4. 안전계획 <span style='font-weight: 500;'>※ 아래 항목 중 실제 안전계획에 포함한 사항만 체크</span>",
        content: "⑤ 안전보건관리 체계도 작성",
        isChecked: "",
      },
      {
        title: "4. 안전계획 <span style='font-weight: 500;'>※ 아래 항목 중 실제 안전계획에 포함한 사항만 체크</span>",
        content: "⑥ 점검계획",
        isChecked: "",
      },
      {
        title: "4. 안전계획 <span style='font-weight: 500;'>※ 아래 항목 중 실제 안전계획에 포함한 사항만 체크</span>",
        content: "⑦ 유지관리계획",
        isChecked: "",
      },
      {
        title: "4. 안전계획 <span style='font-weight: 500;'>※ 아래 항목 중 실제 안전계획에 포함한 사항만 체크</span>",
        content: "⑧ 안전관리 교육이수 계획",
        isChecked: "",
      },
      {
        title: "4. 안전계획 <span style='font-weight: 500;'>※ 아래 항목 중 실제 안전계획에 포함한 사항만 체크</span>",
        content: "⑨ 긴급상황 발생 시 조치체계",
        isChecked: "",
      },
      {
        title: "4. 안전계획 <span style='font-weight: 500;'>※ 아래 항목 중 실제 안전계획에 포함한 사항만 체크</span>",
        content: "⑩ 유해·위험요인 점검 및 조치 계획",
        isChecked: "",
      },
      {
        title: "4. 안전계획 <span style='font-weight: 500;'>※ 아래 항목 중 실제 안전계획에 포함한 사항만 체크</span>",
        content: "⑪ 대피훈련 계획",
        isChecked: "",
      },
      {
        title: "4. 안전계획 <span style='font-weight: 500;'>※ 아래 항목 중 실제 안전계획에 포함한 사항만 체크</span>",
        content: "⑫ 그외 의무사항 이행계획(해당사항 있을 경우)",
        isChecked: "",
      },
      {
        title: "5. 재해예방 업무처리절차(매뉴얼) 마련",
        content: "① 유해위험요인 확인·점검",
        isChecked: "",
      },
      {
        title: "5. 재해예방 업무처리절차(매뉴얼) 마련",
        content: "② 유해위험요인 발견 시 신고·조치 등",
        isChecked: "",
      },
      {
        title: "5. 재해예방 업무처리절차(매뉴얼) 마련",
        content: "③ 재해발생시 대응",
        isChecked: "",
      },
      {
        title: "5. 재해예방 업무처리절차(매뉴얼) 마련",
        content: "④ 비상대피훈련(1종시설물, 교통수단 필수/그외 필요시)",
        isChecked: "",
      },
      {
        title: "6. 안전‧보건 분야별 점검 이행 ※ 점검계획 및 점검대장 표본 제출",
        content: "① 점검 확행 여부<br/>- 「실내공기질 관리법」에 따른 점검<br/>- 「시설물안전법」에 따른 점검<br/>- 기타 시설관련 법률의 안전‧보건 관련 의무",
        isChecked: "",
      },
      {
        title: "6. 안전‧보건 분야별 점검 이행 ※ 점검계획 및 점검대장 표본 제출",
        content: "② 미실시에 따른 후속조치 이행",
        isChecked: "",
      },
      {
        content: "<span style='font-weight: 600;'>7. 유해위험요인 확인·점검 등 관리 이행</span>",
        contentBackgroundColor: "#f9f9f9",
      },
      {
        title: "8. 안전점검 개선사항 조치 여부",
        content: "① 조치계획 수립 여부",
        isChecked: "",
      },
      {
        title: "8. 안전점검 개선사항 조치 여부",
        content: "② 실제조치 여부",
        isChecked: "",
      },
      {
        title: "8. 안전점검 개선사항 조치 여부",
        content: "③ 재해발생시 대응",
        isChecked: "",
      },
      {
        content: "<span style='font-weight: 600;'>9. 비상대피훈련 등 자체 훈련 실시 여부</span>",
        contentBackgroundColor: "#f9f9f9",
      },
      {
        title: "10. 관리상의 조치",
        content: "① 의무이행사항 점검",
        isChecked: "",
      },
      {
        title: "10. 관리상의 조치",
        content: "② 의무이행 미이행시 조치",
        isChecked: "",
      },
      {
        title: "10. 관리상의 조치",
        content: "③ 교육실시 여부 점검",
        isChecked: "",
      },
      {
        title: "10. 관리상의 조치",
        content: "④ 교육 미이행시 조치",
        isChecked: "",
      },
    ],
  },

  {
    isTitleDot: false,
    title: "의무이행사항 점검결과(위탁운영 시설)",
    subTitle: "- 위탁부서 의무사항",
    list: [
      {
        title: "1. 평가기준과 절차 마련",
        content: "① 입찰 시 공고문 상에 안전·보건확보의무 명시",
        isChecked: "",
      },
      {
        title: "1. 평가기준과 절차 마련",
        content: "② 안전계획서 검토",
        isChecked: "",
      },
      {
        title: "1. 평가기준과 절차 마련",
        content: "③ 안전보건 수준 평가",
        isChecked: "",
      },
      {
        title: "1. 평가기준과 절차 마련",
        content: "④ 안전 및 보건확보 의무 서약서 징구",
        isChecked: "",
      },
      {
        title: "2. 재해예방 비용 기준 마련",
        content: "① 예정가격 작성 시 안전보건관리비 반영",
        isChecked: "",
      },
      {
        title: "2. 재해예방 비용 기준 마련",
        content: "② 안전관리비 정산",
        isChecked: "",
      },
      {
        title: "3. 기준·절차에 따른 점검",
        content: "① 반기 1회 이상",
        isChecked: "",
      },
      {
        title: "3. 기준·절차에 따른 점검",
        content: "② 연 1회 이상",
        isChecked: "",
      },
    ]
  },

  {
    isTitleDot: false,
    title: "의무이행사항 점검결과(위탁운영 시설)",
    subTitle: "- 수탁기관 의무사항",
    footer: "※ <span style='color: #EA5455'>(필수)</span> ① 항목별 증빙자료 첨부(4번 안전계획은 제출필요 없음)<br/>" +
      "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
      "② 중복자료는 1건만 제출: 증빙자료에 관련 체크리스트 식별번호 기재 예)5-1~4, 9",
    list: [
      {
        title: "1. 필요한 안전인력을 확보하였음.(업무분장표 첨부)",
        content: "① 안전점검(유해위험요인 확인) 및 유지보수 업무",
        isChecked: "",
      },
      {
        title: "1. 필요한 안전인력을 확보하였음.(업무분장표 첨부)",
        content: "② 안전계획 수립 및 매뉴얼작성 등",
        isChecked: "",
      },
      {
        content: "<span style='font-weight: 600;'>2. 필요한 안전예산을 편성하고 집행하였음.</span>",
        contentBackgroundColor: "#f9f9f9",
      },
      {
        title: "3. 안전점검 계획(계획서 첨부)",
        content: "① 수립(문서화)",
        isChecked: "",
      },
      {
        title: "3. 안전점검 계획(계획서 첨부)",
        content: "② 수행(점검 위탁 포함)",
        isChecked: "",
      },
      {
        title: "4. 안전계획 <span style='font-weight: 500;'>※ 아래 항목 중 실제 안전계획에 포함한 사항만 체크</span>",
        content: "① 수립(문서화)",
        isChecked: "",
      },
      {
        title: "4. 안전계획 <span style='font-weight: 500;'>※ 아래 항목 중 실제 안전계획에 포함한 사항만 체크</span>",
        content: "② 안전관리 대상 현황",
        isChecked: "",
      },
      {
        title: "4. 안전계획 <span style='font-weight: 500;'>※ 아래 항목 중 실제 안전계획에 포함한 사항만 체크</span>",
        content: "③ 조직 및 인력확보",
        isChecked: "",
      },
      {
        title: "4. 안전계획 <span style='font-weight: 500;'>※ 아래 항목 중 실제 안전계획에 포함한 사항만 체크</span>",
        content: "④ 안전예산 편성현황(세부항목별)",
        isChecked: "",
      },
      {
        title: "4. 안전계획 <span style='font-weight: 500;'>※ 아래 항목 중 실제 안전계획에 포함한 사항만 체크</span>",
        content: "⑤ 안전보건관리 체계도 작성",
        isChecked: "",
      },
      {
        title: "4. 안전계획 <span style='font-weight: 500;'>※ 아래 항목 중 실제 안전계획에 포함한 사항만 체크</span>",
        content: "⑥ 점검계획",
        isChecked: "",
      },
      {
        title: "4. 안전계획 <span style='font-weight: 500;'>※ 아래 항목 중 실제 안전계획에 포함한 사항만 체크</span>",
        content: "⑦ 유지관리계획",
        isChecked: "",
      },
      {
        title: "4. 안전계획 <span style='font-weight: 500;'>※ 아래 항목 중 실제 안전계획에 포함한 사항만 체크</span>",
        content: "⑧ 안전관리 교육이수 계획",
        isChecked: "",
      },
      {
        title: "4. 안전계획 <span style='font-weight: 500;'>※ 아래 항목 중 실제 안전계획에 포함한 사항만 체크</span>",
        content: "⑨ 긴급상황 발생 시 조치체계",
        isChecked: "",
      },
      {
        title: "4. 안전계획 <span style='font-weight: 500;'>※ 아래 항목 중 실제 안전계획에 포함한 사항만 체크</span>",
        content: "⑩ 유해·위험요인 점검 및 조치 계획",
        isChecked: "",
      },
      {
        title: "4. 안전계획 <span style='font-weight: 500;'>※ 아래 항목 중 실제 안전계획에 포함한 사항만 체크</span>",
        content: "⑪ 대피훈련 계획",
        isChecked: "",
      },
      {
        title: "4. 안전계획 <span style='font-weight: 500;'>※ 아래 항목 중 실제 안전계획에 포함한 사항만 체크</span>",
        content: "⑫ 그외 의무사항 이행계획(해당사항 있을 경우)",
        isChecked: "",
      },
      {
        title: "5. 재해예방 업무처리절차(매뉴얼) 마련",
        content: "① 유해위험요인 확인·점검",
        isChecked: "",
      },
      {
        title: "5. 재해예방 업무처리절차(매뉴얼) 마련",
        content: "② 유해위험요인 발견 시 신고·조치 등",
        isChecked: "",
      },
      {
        title: "5. 재해예방 업무처리절차(매뉴얼) 마련",
        content: "③ 재해발생시 대응",
        isChecked: "",
      },
      {
        title: "5. 재해예방 업무처리절차(매뉴얼) 마련",
        content: "④ 비상대피훈련(1종시설물, 교통수단 필수/그외 필요시)",
        isChecked: "",
      },
      {
        title: "6. 안전‧보건 분야별 점검 이행 ※ 점검계획 및 점검대장 표본 제출",
        content: "① 점검 확행 여부<br/>- 「실내공기질 관리법」에 따른 점검<br/>- 「시설물안전법」에 따른 점검<br/>- 기타 시설관련 법률의 안전‧보건 관련 의무",
        isChecked: "",
      },
      {
        title: "6. 안전‧보건 분야별 점검 이행 ※ 점검계획 및 점검대장 표본 제출",
        content: "② 미실시에 따른 후속조치 이행",
        isChecked: "",
      },
      {
        content: "<span style='font-weight: 600;'>7. 유해위험요인 확인·점검 등 관리 이행</span>",
        contentBackgroundColor: "#f9f9f9",
      },
      {
        title: "8. 안전점검 개선사항 조치 여부",
        content: "① 조치계획 수립 여부",
        isChecked: "",
      },
      {
        title: "8. 안전점검 개선사항 조치 여부",
        content: "② 실제조치 여부",
        isChecked: "",
      },
      {
        title: "8. 안전점검 개선사항 조치 여부",
        content: "③ 재해발생시 대응",
        isChecked: "",
      },
      {
        content: "<span style='font-weight: 600;'>9. 비상대피훈련 등 자체 훈련 실시 여부</span>",
        contentBackgroundColor: "#f9f9f9",
      },
      {
        title: "10. 관리상의 조치",
        content: "① 의무이행사항 점검",
        isChecked: "",
      },
      {
        title: "10. 관리상의 조치",
        content: "② 의무이행 미이행시 조치",
        isChecked: "",
      },
      {
        title: "10. 관리상의 조치",
        content: "③ 교육실시 여부 점검",
        isChecked: "",
      },
      {
        title: "10. 관리상의 조치",
        content: "④ 교육 미이행시 조치",
        isChecked: "",
      },
    ]
  },
];
